import { render, staticRenderFns } from "./WantDetail.vue?vue&type=template&id=1b8d81d8&scoped=true&"
import script from "./WantDetail.vue?vue&type=script&lang=js&"
export * from "./WantDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=1b8d81d8&prod&scoped=true&lang=css&"
import style1 from "./WantDetail.vue?vue&type=style&index=1&id=1b8d81d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d81d8",
  null
  
)

export default component.exports